import { getBrowserEnvironment } from "../config/environment";

export function getClerkConfig() {
  return { publishableKey: getBrowserEnvironment().clerkPublishableKey };
}
